import { gql } from "@apollo/client";

export const AddPo = gql`
  mutation AddPo(
    $token: String!
    $customerId: ID!
    $finYrId: ID!
    $user_details: SubscribedUser!
    $input: CreatePo!
  ) {
    AddPo(
      token: $token
      customerId: $customerId
      finYrId: $finYrId
      user_details: $user_details
      input: $input
    )
  }
`;
